module.exports = __webpack_public_path__ + "static/media/cyclelogos_triangle.a12be2b0.svg";